import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-subscriptions-page',
  templateUrl: './subscriptions-page.component.html',
  styleUrls: ['./subscriptions-page.component.scss']
})
export class SubscriptionsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
